import { useQuery } from '@tanstack/react-query'
import axios, { AxiosResponse } from 'axios'
import { convertCaseList, ConvertType } from 'utils/convertString'

import { IMyKDCApply, IMyKDCApplyResponse } from '../types'

export const fetchMyKDCApply = async (id: string) => {
  let resp: AxiosResponse<IMyKDCApplyResponse> | undefined
  if (id !== '') {
    resp = await axios.get<IMyKDCApplyResponse>(
      `${window.apiEndpoint}/my/course/v1/kdc-applies?filters=kdc_attr_id:${id}`,
    )
  }
  return convertCaseList(resp?.data, ConvertType.CAMEL)
}

export const useMyKDCApplyQuery = (id: string) => {
  return useQuery<IMyKDCApply[]>({
    queryKey: ['myKDCApply', id],
    queryFn: () => fetchMyKDCApply(id),
    retry: () => (id === '' ? true : false),
  })
}
